import React, { Component } from "react";

class Modal extends Component {
  showCancelButton() {
    if (this.props.showCancelButton) {
      return (
        <button
          className="modal__cancel-btn btn btn--white"
          type="button"
          onClick={() => this.props.cancelAction()}
        >
          {this.props.cancelText}
        </button>
      );
    }

    return "";
  }

  render() {
    let hasDisabled =
        this.props.hasOwnProperty("confirmButtonDisabled") &&
        this.props.confirmButtonDisabled,
      description = (
        <p className="modal__description fs13 tc">{this.props.description}</p>
      );

    if (this.props.hasOwnProperty("htmlDescription")) {
      description = (
        <p
          className="modal__description fs13 tc"
          dangerouslySetInnerHTML={{ __html: this.props.htmlDescription }}
        />
      );
    }

    return (
      <div
        className={`modal fade show scroller-block${
          this.props.hasOwnProperty("className")
            ? " " + this.props.className
            : ""
        }`}
      >
        <div className="modal__content modal-dialog pr">
          <div className="table">
            <div className="table-cell">
              <div className="modal__inner pr">
                <h3 className="modal__title monserrat-medium fs30 tc">
                  {this.props.title}
                </h3>

                {description}
            
                <button
                  className={`modal__submit-btn btn btn--with-space btn--yellow${
                    hasDisabled ? " btn--loading" : ""
                  }`}
                  type="button"
                  disabled={hasDisabled}
                  onClick={() => this.props.agreeAction()}
                >
                  {this.props.agreeText}
                </button>
                {this.showCancelButton()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;
